import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, Col, Row } from 'reactstrap';

const DepartmentPieChart = React.memo(
  ({ associateCountDepartment, loadingCountDept }) => {
    const chartColors = ['#A6478E', '#777aca', '#a8aada', '#ff6347', '#32cd32'];
    const series = associateCountDepartment.map((item) => item.associatesCount);
    const dynamicColors = associateCountDepartment.map(
      (_, index) => chartColors[index % chartColors.length]
    );
    const checkLongChar = associateCountDepartment.some(
      (item) => item.department?.length > 5
    );

    const options = {
      chart: {
        width: 227,
        height: 227,
        type: 'pie',
      },
      labels: ['HR', 'IT', 'TEST'],
      colors: dynamicColors,
      stroke: {
        width: 0,
      },
      legend: {
        show: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
              height: 200,
            },
          },
        },
      ],
    };

    return (
      <Col xl={4} lg={4} md={5} sm={12}>
        <Card className="card-h-100 rounded-2">
          <CardBody>
            <div className="d-flex flex-wrap align-items-center mb-2">
              <h6 className="card-title me-2">Employees per Department</h6>
            </div>
            <Row className="align-items-center">
              <div className="d-flex justify-content-center">
                {!loadingCountDept && associateCountDepartment.length > 0 ? (
                  <div className="d-flex flex-row">
                    <div style={{ width: '71%', height: '220px' }}>
                      <ReactApexChart
                        options={{
                          chart: {
                            width: 227,
                            height: 227,
                            type: 'pie',
                          },
                          labels: associateCountDepartment.map(
                            (item) => item.department ?? ''
                          ),
                          colors: dynamicColors,
                          stroke: {
                            width: 0,
                          },
                          legend: {
                            show: false,
                          },
                          responsive: [
                            {
                              breakpoint: 480,
                              options: {
                                chart: {
                                  width: 200,
                                  height: 200,
                                },
                              },
                            },
                          ],
                        }}
                        series={series}
                        type="pie"
                        height={220}
                      />
                    </div>
                    <div
                      className={`col-sm align-self-center ${
                        checkLongChar ? 'ms-2' : 'ms-4'
                      }`}
                    >
                      <div className="mt-4 mt-sm-0">
                        {associateCountDepartment.map((item, index) => (
                          <div
                            key={item.department}
                            className={index !== 0 ? 'mt-4 pt-2' : ''}
                          >
                            <p className="mb-2 adjust-pie-title">
                              <i
                                className="inline-block w-2 h-2 mr-2 rounded-full"
                                style={{
                                  backgroundColor: chartColors[index],
                                  width: '10px',
                                  height: '10px',
                                  display: 'inline-block',
                                  marginRight: '8px',
                                  borderRadius: '8px',
                                }}
                              />
                              {item.department}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : loadingCountDept ? (
                  <h6 className="text-muted mt-4">Loading...</h6>
                ) : (
                  <h6 className="text-muted mt-4">No Employees Department</h6>
                )}
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
);

export default DepartmentPieChart;
